commusoftCommon.service('sharedPhraises', function($rootScope) {
    $rootScope.error_messages = {};

    this.create = function create() {
        $rootScope.error_messages.fatal_error = "There has been an error please contact us on 0123456789";
        $rootScope.error_messages.unsaved_sidepanel = "Form in progress. Are you sure you want to close side panel without saving?";
        $rootScope.error_messages.no_filters_present = "Please select a valid filter";
    }
});